import { createApi } from '@reduxjs/toolkit/query/react';
import { Questions, User } from 'src/config/api/models/User';
import { appBaseQuery } from '../helpers';
import apiRoutesV2 from 'src/config/api/routes';

export type SaveSurvey = {
  answer?: number;
  multiChoiceAnswer?: string;
} & Questions;

export type SaveSurveyRequest = {
  key: string;
  answer?: number;
  multiChoiceAnswer?: string;
};

export const surveyApi = createApi({
  reducerPath: 'surveyApi',
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    saveSurvey: builder.mutation<
      void,
      { key: NonNullable<User['survey']>['key']; payload: SaveSurveyRequest[] }
    >({
      query: ({ key, payload }) => ({
        url: apiRoutesV2.survey(key),
        method: 'POST',
        body: payload,
      }),
    }),
    postponeSurvey: builder.mutation<void, { key: string }>({
      query: ({ key }) => ({
        url: apiRoutesV2.survey(key),
        method: 'PATCH',
      }),
    }),
    refusingSurvey: builder.mutation<void, { key: string }>({
      query: ({ key }) => ({
        url: apiRoutesV2.survey(key),
        method: 'DELETE',
      }),
    }),
    answerdExternalSurvey: builder.mutation<void, { key: string }>({
      query: ({ key }) => ({
        url: apiRoutesV2.answerdExternalSurvey(key),
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useSaveSurveyMutation,
  usePostponeSurveyMutation,
  useRefusingSurveyMutation,
  useAnswerdExternalSurveyMutation,
} = surveyApi;
